// frontend/smartdocs-admin/src/components/settings/AdvancedSettings.tsx
import React from 'react';
import { useSettings } from '@/context/SettingsContext';
import ToggleSwitch from '@shared/ToggleSwitch';
import SettingsPage from "@/pages/SettingsPage";
import Card from "@shared/Card";

const AdvancedSettings: React.FC = () => {
  const { settings, updateSetting, loading } = useSettings();

  const advancedSettings = settings.Advanced || {};

  const handleUpdate = (key: string, value: any) => {
    updateSetting('Advanced', key, value);
  };

  return (
    <SettingsPage>
      <Card>
        <div className="space-y-6">
        {/*<h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4">Advanced System Configurations</h2>*/}

        {/* Enable API Debug Mode */}
        <div className="flex items-center justify-between">
          <div>
            <label htmlFor="apiDebugMode" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable API Debug Mode</label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Expose more detailed error messages and request/response logs for debugging purposes.</p>
          </div>
          <ToggleSwitch
            id="apiDebugMode"
            label=""
            checked={advancedSettings.apiDebugMode || false}
            onChange={(e) => handleUpdate('apiDebugMode', e.target.checked)}
            disabled={loading}
          />
        </div>

        {/* Enable Maintenance Mode */}
        <div className="flex items-center justify-between">
          <div>
            <label htmlFor="maintenanceMode" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Enable Maintenance Mode</label>
            <p className="text-sm text-gray-500 dark:text-gray-400">Temporarily take the application offline for maintenance, displaying a custom message to users.</p>
          </div>
          <ToggleSwitch
            id="maintenanceMode"
            label=""
            checked={advancedSettings.maintenanceMode || false}
            onChange={(e) => handleUpdate('maintenanceMode', e.target.checked)}
            disabled={loading}
          />
        </div>

        {/* Maintenance Message */}
        <div>
          <label htmlFor="maintenanceMessage" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Maintenance Message</label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">The message displayed to users when the application is in maintenance mode.</p>
          <textarea
            id="maintenanceMessage"
            rows={3}
            className="p-2 mt-1 block w-full rounded-md border-1 border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            value={advancedSettings.maintenanceMessage || 'SmartDocs AI is currently undergoing scheduled maintenance. We will be back shortly!'}
            onChange={(e) => handleUpdate('maintenanceMessage', e.target.value)}
            disabled={loading}
          ></textarea>
        </div>

        {/* Database Backup Schedule */}
        <div>
          <label htmlFor="backupSchedule" className="block text-sm font-medium text-gray-700 dark:text-gray-300">Database Backup Schedule</label>
          <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">Set the frequency for automatic database backups.</p>
          <select
            id="backupSchedule"
            className="mt-1 block w-full h-12 rounded-md border-1 border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            value={advancedSettings.backupSchedule || 'daily'}
            onChange={(e) => handleUpdate('backupSchedule', e.target.value)}
            disabled={loading}
          >
            <option value="daily">Daily</option>
            <option value="weekly">Weekly</option>
            <option value="monthly">Monthly</option>
            <option value="manual">Manual</option>
          </select>
        </div>
      </div>
      </Card>
    </SettingsPage>
  );
};

export default AdvancedSettings;
